import React from 'react'
import moment from 'moment'
import { Text } from '@fundamentals'
import { Task } from '@core/entities/task/Task'
import { Card } from '@common/material'
import { CardContent, Divider } from '@mui/material'
import { localizedStrings } from '@core/strings'
import { TaskRequestApproveChangesActions } from '@modules/tasks/taskDetails/components/TaskRequestApproveChangesActions'

type TaskRequestApproveChangesCardProps = {
  task: Task
}

export const TaskRequestApproveChangesCard: React.FC<
  TaskRequestApproveChangesCardProps
> = ({ task }) => {
  const getTitle = () => {
    if (task?.hasRequestedChanges()) {
      return localizedStrings.changesRequested
    }

    if (task?.hasAddressedChanges()) {
      return localizedStrings.changesAddressed
    }

    return localizedStrings.approvalRequest
  }

  return (
    <Card>
      <CardContent>
        <Text
          sx={{ fontSize: '16px' }}
          variant='h6'
          color='text.primary'
          gutterBottom
        >
          {getTitle()}
        </Text>
        <Divider sx={{ mb: 1.5 }} />

        {!task?.hasRequestedChanges() && !task?.hasAddressedChanges() && (
          <>
            <Text variant='body2' color='text.disabled'>
              {`${localizedStrings.requestedBy}: ${task
                ?.getPreviousStepSubmittedBy()
                ?.getFullName()}`}
            </Text>

            <Text variant='body2' color='text.disabled' mt={1}>
              {`${localizedStrings.date}: ${moment(task?.createdOn).format(
                'Do MMM YYYY HH:mm',
              )}`}
            </Text>
          </>
        )}

        {task?.hasRequestedChanges() && task?.hasRequestedChangesComment() && (
          <Text sx={{ fontSize: '14px', mb: 1.5 }}>
            {task?.lastRequestedChange?.comment}
          </Text>
        )}

        {task?.hasRequestedChanges() && (
          <>
            <Text variant='body2' color='text.disabled'>
              {`${
                localizedStrings.requestedBy
              }: ${task.lastRequestedChange.requestedBy?.getFullName()}`}
            </Text>

            <Text variant='body2' color='text.disabled' mt={1}>
              {`${localizedStrings.date}: ${moment(
                task?.lastRequestedChange.requestedAt,
              ).format('Do MMM YYYY HH:mm')}`}
            </Text>
          </>
        )}

        {task?.hasAddressedChanges() && (
          <>
            <Text variant='body2' color='text.disabled'>
              {`${
                localizedStrings.addressedBy
              }: ${task.lastRequestedChange?.addressedBy?.getFullName()}`}
            </Text>
          </>
        )}

        <TaskRequestApproveChangesActions
          task={task}
          flexDirection='column'
          mt={2}
          fullWidth
        />
      </CardContent>
    </Card>
  )
}
